var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMixerIconBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 37.94 37.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3.97,
    y1: 33.98,
    x2: 38.06,
    y2: -0.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#004666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#002548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#001d41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#001b3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c1336"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 37.94,
    height: 37.94,
    rx: 6.41
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixerIconBg);
export default __webpack_public_path__ + "static/media/MixerIconBG.6b3dbb73e4e51f435f1ba0d16d4f4435.svg";
export { ForwardRef as ReactComponent };